module.exports = __webpack_public_path__ + "media/images/products/shop/3-6024311d9a63000466a616e37a52e80a.jpg";